import moment from "moment";

const DateFormatter = {
  formatDateOnly: (date) => {
    return moment(date).format("DD");
  },
  formatDateMonth: (date) => {
    return moment(date).format("DD MMM");
  },
  formatDateFull: (date) => {
    return moment(date).format("DD MMM YYYY");
  },
  formatMonthYear: (date) => {
    return moment(date).format("MMM YYYY");
  },
  formatDatetimeFull: (date, locale) => {
    if (locale === "th") {
      return moment(date).locale(locale).format("dd DD MMM YYYY HH:mm");
    } else {
      return moment(date).locale(locale).format("ddd DD MMM YYYY HH:mm");
    }
  },
  formatOneWeek: (date) => {
    return parseInt(moment(date).subtract(2, "weeks").startOf("isoWeek").format("DD")) + 1;
  },
  formatYesterDay: (date) => {
    return moment(date).subtract(1, "days").format("LLLL");
  },
  formatLast7d: (date) => {
    return moment(date).subtract(7, "days").format("LLLL");
  },
  formatDelOneDay: (date) => {
    const dates = date || new Date();
    return dates.setDate(dates.getDate() - 1);
  },
  formatAddOneDay: (date) => {
    const dates = date || new Date();
    return dates.setDate(dates.getDate() + 1);
  },
  formatIsoDate: (date) => {
    return moment(date).format("LLLL");
  },
};

export default DateFormatter;
